import * as React from "react";
import { observer } from "mobx-react";
import { UitkCard, UitkCardLink } from "uitk-react-cards";
import { UitkHeading, UitkText } from "uitk-react-text";
import { UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";
import { UitkScrim, UitkScrimType } from "uitk-react-scrim";
import { Action } from "components/utility/analytics/FlexAnalyticsUtils";
import { TrackedLink } from "components/utility/analytics/TrackedLink";
import { DestinationOfferPriceInfo } from "../DestinationOfferPriceInfo/DestinationOfferPriceInfo";
import { CampaignRecommendationsWithOffersQuery } from "../../../../../../__generated__/api";
import Offers = CampaignRecommendationsWithOffersQuery.Offers;
import { destinationOfferItem } from "../../Common/MerchCampaignCard/MerchCampaignCard";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { LazyLoadedImage } from "components/utility/LazyLoadedImage/LazyLoadedImage";

export interface FullBleedCardProps {
  offer: Offers;
  productType: string;
  cardIndex: number;
  campaignId: string;
  displayDate: boolean;
  displayPrice: boolean;
  moduleName: string;
  border?: boolean;
}

export const FullBleedCard = observer(
  ({
    offer,
    productType,
    cardIndex,
    campaignId,
    displayDate,
    displayPrice,
    moduleName,
    border,
  }: FullBleedCardProps) => {
    if (offer.__typename !== "DestinationOfferItem") {
      return null;
    }

    const offerItem = destinationOfferItem(productType, offer);

    if (offerItem === null || offerItem === undefined) {
      return null;
    }

    return (
      <>
        <UitkCard className="FullBleedCard" border={border}>
          <UitkFigure ratio={UitkFigureAspectRatioType.R3_2}>
            <LazyLoadedImage src={offer.image.url} alt={offer.image.description} />
            <UitkScrim type={UitkScrimType.BOTTOM}>
              <UitkLayoutFlex justifyContent="space-between">
                <>
                  <UitkLayoutFlexItem>
                    <div>
                      <UitkHeading tag="h3" size={5}>
                        {offer.name}
                      </UitkHeading>
                      {displayDate && <UitkText size={300}>{offer.dates}</UitkText>}
                      <UitkText size={300}>{offer.secondaryContent}</UitkText>
                    </div>
                  </UitkLayoutFlexItem>
                  <UitkLayoutFlexItem className="uitk-type-right">
                    <div>
                      {displayPrice && offerItem.price.value && (
                        <DestinationOfferPriceInfo
                          scrimDisplay
                          offerPrice={offerItem.price}
                          cardIndex={cardIndex}
                          campaignId={campaignId}
                        />
                      )}
                      {displayPrice && offerItem.price.checkPriceText && (
                        <div className="uitk-scrim">
                          <a
                            className="cardContent uitk-link uitk-type-300 uitk-type-bold"
                            href={offerItem.actionLink.href}
                          >
                            {offerItem.price.checkPriceText}
                          </a>
                        </div>
                      )}
                    </div>
                  </UitkLayoutFlexItem>
                </>
              </UitkLayoutFlex>
            </UitkScrim>
          </UitkFigure>
          <UitkCardLink>
            <TrackedLink
              moduleName={moduleName}
              action={Action.CLICK}
              href={offerItem.actionLink.href}
              rfrr={`card-${campaignId}-${cardIndex}`}
            >
              {offerItem.actionLink.text}
            </TrackedLink>
          </UitkCardLink>
        </UitkCard>
      </>
    );
  }
);
